import { BillingCategoryCode } from '@models/Receipt'
import { get } from './axios'

//////////////////////////////////////////////////////////////////////
// GET
//////////////////////////////////////////////////////////////////////

/**
 * search
 */

export type SearchParams = {
  buildingName: string
  roomName: string
}

type SearchResponseData = {
  buildingId: number
  roomId: number
  isDormitory: boolean
  paymentMethods: (typeof BillingCategoryCode.CreditCard | typeof BillingCategoryCode.AccountTransfer)[]
}

export const search = async (params: SearchParams) => {
  return await get<SearchResponseData>('/v1/buildings/search', params, false)
}
